import TextBuilder from '../Builder/Text';
export var Subtitle = TextBuilder({
  tagName: 'h2',
  className: 'subtitle'
});